<template>
  <div id="live">
    <div class="meta">
      <div class="title">{{ $t("miclive.live.title") }}</div>
      <div class="button refresh" @click="refresh()">
        {{ $t("miclive.live.refresh") }}
      </div>
    </div>
    <div class="selector">
      <select @change="selectCategory($event)">
        <option value="-1">{{
          $t("miclive.competition.all_categories")
        }}</option>
        <option
          v-for="category in categories"
          :key="category.id"
          :value="category.id"
          >{{ category.name }}</option
        >
      </select>
      <template v-if="category">
        <select @change="selectGroup($event)">
          <option value="-1">{{ $t("miclive.competition.all_groups") }}</option>
          <option
            v-for="group in category.groups"
            :key="group.id"
            :value="group.id"
            >{{ $t("miclive.competition.group") }} {{ group.name }}</option
          >
        </select>
      </template>
    </div>
    <template v-if="matches">
      <template v-if="Object.values(matches).length > 0">
        <div class="matches">
          <Match v-for="match in matches" :key="match.id" :item="match"></Match>
        </div>
      </template>
      <template v-else>
        <div class="empty">
          {{ $t("miclive.live.empty") }}
        </div>
      </template>
    </template>
    <template v-else>
      <div class="loader"></div>
    </template>

    <template v-if="sponsor">
        <img
        class="sponsor"
        :src="sponsor"
        loading="lazy"
        height="300"
      />
    </template>
  </div>
</template>

<script>
import { Api } from "@/core/api.js";
import Match from "@/components/domain/competition/match";
const api = new Api();
const TIMEOUT = 10 * 1000;
const AUTOTIMEOUT = 10 * 1000;

export default {
  name: "Live",
  components: {
    Match
  },
  data() {
    return {
      matches: {},
      category: false,
      group: false,
      timer: false,
      autotimer: false
    };
  },
  computed: {
    categories() {
      var result = this.$store.getters["competition/getCategories"]();
      return result || false;
    },
    sponsor() {
      var result = this.$store.getters["getSponsors"]("live");
      return result || false;
    }
  },
  methods: {
    load() {
      if (!this.category && this.categories) {
        this.category = this.categories[Object.values(this.categories)[0]];
        if (this.category && !this.group) {
          this.group = this.category.groups[
            Object.values(this.category.groups)[0]
          ];
        }
      }
      var self = this;
      this.matches = false;
      var params = {};
      if (this.category) params.category_id = this.category.id;
      if (this.group) params.group_id = this.group.id;
      api.post("miclive/matches/current", params).then(function(data) {
        self.matches = data.data;
        //   self.matches = {};
      });
    },
    selectCategory(event) {
      this.category = this.categories[event.target.value];
      this.group = false;
      this.load();
    },
    selectGroup(event) {
      this.group = this.category.groups[event.target.value];
      this.load();
    },
    refresh() {
      var self = this;
      if (!this.timer) {
        self.load();
        this.timer = setTimeout(() => {
          clearTimeout(self.timer);
          self.timer = null;
        }, TIMEOUT);
      }
    },
    autorefresh() {
      var self = this;
      if (!this.autotimer) {
        this.autotimer = setInterval(() => {
          self.load();
        }, self.$store.getters["getRefreshTime"]);
      }
    }
  },
  created() {
    this.load();
    this.autorefresh();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    clearInterval(this.autotimer);
  }
};
</script>

<style lang="scss" scoped>
.selector {
  select {
    width: 100%;
    padding: 15px 10px;
    margin-bottom: 10px;
    border: none;
    outline: none;
    border-radius: 4px;
    background: #fff;
  }
}

.empty {
  background: url("~@/../public/img/rest.svg") no-repeat top 100px center;
  background-size: 100px;
  width: 100%;
  height: 400px;
  padding-top: 250px;
  text-align: center;
}

.meta {
  margin-bottom: 10px;
  overflow: hidden;
  .title {
    float: left;
    width: calc(100% - 150px);
    padding-top: 10px;
  }
  .refresh {
    float: right;
    width: 150px;
    background: url("~@/../public/img/refresh.svg") no-repeat center left 10px
      #fff;
    background-size: 20px;
    padding: 10px;
    padding-left: 35px;
    color: #222;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 14px;
  }
}

.matches {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: minmax(0, 1fr);
}

.tablet {
  .matches {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
.laptop {
  .matches {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) !important;
  }
}
.desktop {
  .matches {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(
        0,
        1fr
      ) !important;
  }
}
</style>
